class ThreeAR {
  static renderer = null;
  static scene = null;
  static camera = null;
}

export default ThreeAR